{
  "salon-search-result-page": {
    "buttons": {
      "book-appointment": "TERMIN BUCHEN",
      "explore": "ENTDECKEN",
      "show-more": "MEHR ANZEIGEN"
    },
    "text": {
      "salon-around": "Salons in der Nähe"
    }
  }
}
